// extracted by mini-css-extract-plugin
module.exports = {"bookTable":"BulkAddPage_bookTable__1pafu"};